import { pendingAmendment } from "@makit/shared";
import { Navigate, useNavigate } from "react-router-dom";

import { PageHead } from "../app/PageHead";
import { AmendmentNotice, amendmentTitle } from "../features/policy-amendment/AmendmentNotice";

/** `W-90` 바뀌는 내용. 공개 문서가 바뀔 때 알리는 화면(PRD `7.5.17`, 목업 `W-90`).
 *
 * 본문은 범용 장치(`features/policy-amendment/AmendmentNotice.tsx`)가 값으로 그린다. 로그인한 뒤 첫 화면 위에
 * 한 번 열리고(`app/Shell.tsx`), 시행일까지 마이페이지(`W-70`) 맨 위 줄에서 다시 연다.
 *
 * ⛔ 버튼은 `확인` 하나다(`동의` 가 아니다). `확인` 은 앞 화면으로 돌아갈 뿐 아무것도 기록하지 않는다.
 * 띄울 개정이 없으면(상수 없음 · 시행일 자리 표시 · 이미 시행) 마이페이지로 보낸다. */
export function PolicyNoticeScreen() {
  const navigate = useNavigate();
  const amendment = pendingAmendment();
  if (!amendment) return <Navigate to="/account" replace />;

  return (
    <>
      <PageHead frame="W-90" title={amendmentTitle(amendment)} subtitle={`시행일 ${amendment.effectiveDate}`} />
      <AmendmentNotice
        amendment={amendment}
        onConfirm={() => {
          // 이 화면으로 바로 들어왔으면 돌아갈 앞 화면이 없다. 그때는 내 작업으로 간다.
          if (window.history.length > 1) navigate(-1);
          else navigate("/jobs", { replace: true });
        }}
      />
    </>
  );
}
